var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    fill: "none",
    customFrame: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_5",
    x1: 6.73288155,
    x2: 34.7611084,
    y1: 19.3564777,
    y2: 30.2467709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(151,87,230)",
    offset: 0,
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(118,56,241)",
    offset: 0.999890745,
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_6",
    x1: 11.999999,
    x2: 33.4575119,
    y1: 24.6884022,
    y2: 38.3658981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: 0,
    stopOpacity: 0.259751976
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(147,83,232)",
    offset: 0.999890745,
    stopOpacity: 0.637265086
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_7",
    x1: 24.25,
    x2: 24.25,
    y1: 19,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: 0,
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: 1,
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4\\u5408 2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 24,
    cy: 24,
    r: 24,
    fill: "rgb(141,86,233)",
    fillOpacity: 0.109999999
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62",
    d: "M12.0469 14.7484L25.7085 12.0928C28.4192 11.5659 31.0438 13.3362 31.5707 16.0469L33.8294 27.667C34.3563 30.3777 32.586 33.0023 29.8754 33.5292L16.2137 36.1847C13.503 36.7116 10.8784 34.9413 10.3515 32.2306L8.0928 20.6105C7.5659 17.8998 9.33621 15.2753 12.0469 14.7484Z",
    fill: "url(#paint_linear_5)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    width: 24.5,
    height: 18.5,
    x: 12,
    y: 19,
    rx: 2,
    fill: "url(#paint_linear_6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    width: 24.5,
    height: 18.5,
    x: 12,
    y: 19,
    rx: 2,
    stroke: "url(#paint_linear_7)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u8DEF\\u5F84-14",
    x1: 14,
    x2: 21.4932098,
    y1: 24,
    y2: 24,
    stroke: "rgb(255,255,255)",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84-14\\u5907\\u4EFD",
    d: "M14 28L16.1766 28L17.9127 28",
    stroke: "rgb(255,255,255)",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 30,
    cy: 25.25,
    r: 2.25,
    stroke: "rgb(255,255,255)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    d: "M35 33.25C35 30.4886 32.7614 28.25 30 28.25C27.2386 28.25 25 30.4886 25 33.25",
    fillRule: "evenodd",
    stroke: "rgb(255,255,255)",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadStep2);
export default __webpack_public_path__ + "static/media/download-step-2.07756fbe722657a5bc74a13f60a10ff9.svg";
export { ForwardRef as ReactComponent };